import React, { useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTheme } from '@mui/material/styles';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import EirOrderedItem from './EirOrderedItem';

import {
  BroadbandIcon,
  MobileIcon,
  SIMIcon,
  TvIcon,
  MobileBroadbandIcon,
} from '../shared/CustomIcons.styled';
import styles from './style';
import EirOfferDiscounts from './EirOfferDiscounts';
import EirMissingStep from './EirMissingStep';
import RootContext from '../../../util/root.context';
import priceFormatter from '../../../util/priceFormatter';
import useLocalStorage from '../../hooks/useLocalStorage';
import { getCookie } from '../../hooks/useCookie';
import CheckoutSimSelector from '../eir-simtype-selector/checkoutSimSelector';

const { publicRuntimeConfig } = getConfig();
const EirOrderedOfferType = ({
  summaryData,
  tacticalOffers,
  cartData,
  loading,
  deleteIcon,
  missingStep,
  openConfirmationModal,
  getClickedItem,
  isCartDoc,
  // isCurrentServiceComplete,
  setHasMissingStep,
  systemAddedOffer,
  setIncompleteCart,
  cmsData,
  pSIMCode,
  refreshSummary,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const { state, dispatch } = useContext(RootContext);
  const localStore = useLocalStorage();
  const [cartAfterSIMupdate, setCartAfterSIMupdate] = useState(cartData);

  React.useState(() => {
    if (
      loading === false &&
      cartData.hasBillPayPlans === true &&
      cartData.hasUpfrontCostItem === false
    ) {
      setHasMissingStep(true);
      localStore.setLocalStorage('INCOMPLETE_CART', true);
    } else if (
      loading === false &&
      cartData.hasBillPayPlans === true &&
      cartData.hasUpfrontCostItem === true
    ) {
      setHasMissingStep(false);
      localStore.removeLocalStorage('INCOMPLETE_CART');
    } else if (loading === false) {
      setHasMissingStep(false);
      localStore.removeLocalStorage('INCOMPLETE_CART');
    }
  }, [setHasMissingStep, loading, missingStep, cartData]);

  return (
    <Box sx={{ pt: 2 }}>
      <Box>
        {cartData?.hasBroadband && (
          <Box>
            <Stack direction='row' alignItems='flex-end'>
              <BroadbandIcon />
              <Typography
                variant='subtitle1'
                component='p'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.cartItemText?.broadbandTitle}
              </Typography>
            </Stack>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.cart
                ?.filter(res => res?.itemType === 'DUALPLAY')
                .map(cart => (
                  <>
                    <EirOrderedItem
                      {...cart}
                      key={uuidv4()}
                      loading={loading}
                      cartData={cartData}
                      deleteIcon={deleteIcon}
                      openConfirmationModal={openConfirmationModal}
                      getClickedItem={getClickedItem}
                      isCartDoc={isCartDoc}
                    />
                    {cart.addOns.map(addOn => (
                      <EirOrderedItem
                        {...addOn}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                        isCartDoc={isCartDoc}
                      />
                    ))}
                    {missingStep ||
                      (!cart?.appointmentType && (
                        <Box
                          sx={{ ...styles(theme).itemDiscountContainer, padding: '0 0 0.5rem 0' }}
                        >
                          {getCookie('cart_Type') === 'CHANGE_OFFER' ? (
                            ''
                          ) : (
                            <EirMissingStep
                              loading={loading}
                              setIncompleteCart={setIncompleteCart}
                              action={() => {
                                router.push(
                                  `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband/current-service`
                                );
                              }}
                              ctaText='Complete info'
                              missingStepMessage='Check the questions about your current service'
                              ariaLabel='Complete the information on your current service'
                            />
                          )}
                        </Box>
                      ))}
                  </>
                ))}
            </Box>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.activationData
                ?.filter(res => res.serviceType === 'DUALPLAY' && res.price > 0)
                .map(active => (
                  <EirOrderedItem
                    {...active}
                    key={uuidv4()}
                    loading={loading}
                    cartData={cartData}
                    isCartDoc={isCartDoc}
                  />
                ))}
            </Box>
            {getCookie('cart_Type') === 'CHANGE_OFFER' ? (
              ''
            ) : (
              <>
                <Box sx={styles(theme).itemContainer}>
                  {cartData?.cart?.map(
                    item =>
                      item?.activation?.activationFeeDiscount > 0 && (
                        <EirOfferDiscounts
                          key={uuidv4()}
                          loading={loading}
                          description={`No Set Up Fees! Free Activation & Installation worth ${priceFormatter(
                            item?.activation?.activationFeeDiscount
                          )}`}
                          cmsData={cmsData}
                        />
                      )
                  )}
                </Box>
                <Box sx={styles(theme).itemContainer}>
                  {tacticalOffers?.map(tactOff => (
                    <EirOfferDiscounts
                      {...tactOff}
                      key={uuidv4()}
                      loading={loading}
                      tacticalOffers={tacticalOffers}
                      cmsData={cmsData}
                    />
                  ))}
                </Box>
              </>
            )}
            {/* Removing Discounts */}
            {/* <Box sx={styles(theme).itemDiscountContainer}>
              {cartData?.discountData
                ?.flat()
                .filter(s => s.serviceType === 'DUALPLAY')
                .map((cart, index) => (
                  <EirOfferDiscounts {...cart} key={index} loading={loading} cartData={cartData} />
                ))}
            </Box> */}
          </Box>
        )}
        {cartData?.hasTVOffer && (
          <>
            {cartData?.hasBroadband && (
              <Divider sx={{ borderColor: theme.palette.primary.offerMain }} />
            )}
            <Stack
              direction='row'
              alignItems='flex-end'
              sx={{ pt: cartData?.hasBroadband ? 2 : 0 }}
            >
              <TvIcon />
              <Typography
                variant='subtitle1'
                component='p'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.cartItemText?.tvTitle}
              </Typography>
            </Stack>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.cart
                ?.filter(res => res.itemType === 'TV')
                .map(cart => (
                  <>
                    <EirOrderedItem
                      {...cart}
                      key={uuidv4()}
                      loading={loading}
                      cartData={cartData}
                      deleteIcon={deleteIcon}
                      openConfirmationModal={openConfirmationModal}
                      getClickedItem={getClickedItem}
                      isCartDoc={isCartDoc}
                    />
                    {cart?.addOns?.map(addOn => (
                      <EirOrderedItem
                        {...addOn}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                        isCartDoc={isCartDoc}
                      />
                    ))}
                    {cart?.activation?.price > 0 && (
                      <EirOrderedItem
                        {...cart.activation}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        isCartDoc={isCartDoc}
                      />
                    )}
                  </>
                ))}
            </Box>
          </>
        )}
        {cartData?.hasBillPayPlans && !systemAddedOffer && (
          <>
            {(cartData?.hasBroadband || cartData?.hasTVOffer) && (
              <Divider sx={{ borderColor: theme.palette.primary.offerMain }} />
            )}
            <Stack
              direction='row'
              alignItems='flex-end'
              sx={{ pt: cartData?.hasBroadband || cartData?.hasTVOffer ? 2.5 : 0 }}
            >
              <MobileIcon />
              <Typography
                variant='subtitle1'
                component='p'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.cartItemText?.mobileTitle}
              </Typography>
            </Stack>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.cart
                ?.filter(res => res.itemType === 'MOBILE' && !res.isSimOnly)
                .map((cart, index) => (
                  <>
                    <EirOrderedItem
                      {...cart}
                      key={uuidv4()}
                      loading={loading}
                      cartData={cartData}
                      deleteIcon={deleteIcon}
                      openConfirmationModal={openConfirmationModal}
                      getClickedItem={getClickedItem}
                      isCartDoc={isCartDoc}
                    />

                    {cart?.handsetData?.map(set => (
                      <EirOrderedItem
                        {...set}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                        isCartDoc={isCartDoc}
                      />
                    ))}
                    {cmsData && getCookie('cart_Type') !== 'CHANGE_OFFER' && (
                      <Box
                        sx={{
                          ml: {
                            xs: 0,
                            sm: 1,
                          },
                        }}
                      >
                        {cart?.handsetData?.map(set => (
                          <CheckoutSimSelector
                            SIMType={
                              cartAfterSIMupdate?.cart?.filter(
                                res => res.offerId === cart?.offerId
                              )[0]?.SIMCode === pSIMCode
                                ? 'ALL_IN_1'
                                : 'ESIM'
                            }
                            SIMCardType={set?.SIMCardType}
                            setCartAfterSIMupdate={setCartAfterSIMupdate}
                            offerId={cart?.offerId}
                            refreshSummary={refreshSummary}
                            SIMOnly={false}
                            pSIMCode={pSIMCode}
                            cmsData={cmsData}
                          />
                        ))}
                      </Box>
                    )}
                    {cart?.addOns.map(param => (
                      <EirOrderedItem
                        {...param}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                        isCartDoc={isCartDoc}
                      />
                    ))}
                    {cart?.activation?.price > 0 && (
                      <EirOrderedItem
                        {...cart.activation}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        isCartDoc={isCartDoc}
                      />
                    )}
                    {cart?.handsetData &&
                      cart?.handsetData[0]?.insuranceAddOnData?.addOnId &&
                      cart?.handsetData?.map(set => (
                        <EirOrderedItem
                          {...set.insuranceAddOnData}
                          key={uuidv4()}
                          loading={loading}
                          cartData={cartData}
                          deleteIcon={deleteIcon}
                          openConfirmationModal={openConfirmationModal}
                          getClickedItem={getClickedItem}
                          isCartDoc={isCartDoc}
                        />
                      ))}
                    <Stack sx={styles(theme).mobileItemDiscountContainer}>
                      {cart?.discountData
                        ?.flat()
                        .filter(s => s.serviceType === 'MOBILE' && !s.isSimOnly)
                        .map(cart1 => (
                          <EirOfferDiscounts
                            {...cart1}
                            key={uuidv4()}
                            loading={loading}
                            cartData={cartData}
                            cmsData={cmsData}
                          />
                        ))}
                    </Stack>
                    {missingStep ||
                      (cart?.handsetData?.length === 0 && (
                        <Box sx={styles(theme).missingItem}>
                          <EirMissingStep
                            loading={loading}
                            setIncompleteCart={setIncompleteCart}
                            action={() => {
                              localStore.setLocalStorage('BILLPAY_JOURNEY', true);
                              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
                              dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: true });
                            }}
                            ctaText='Add handset'
                            missingStepMessage='A handset needs to be added to this offer'
                            ariaLabel='	A handset needs to be added'
                          />
                        </Box>
                      ))}
                    {cart?.portIn === true && cart?.portInInfo === false && !missingStep && (
                      <Box sx={{ ...styles(theme).itemDiscountContainer, padding: '0rem' }}>
                        <EirMissingStep
                          loading={loading}
                          setIncompleteCart={setIncompleteCart}
                          action={() => {
                            router.push(
                              `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/porting/?id=${cart.offerId}`
                            );
                          }}
                          ctaText='Check info'
                          missingStepMessage='Verify relevant porting information is complete'
                          ariaLabel='Relevant porting information is required'
                        />
                      </Box>
                    )}
                    {missingStep ||
                      (state.insuranceTermsChecked.status &&
                        state.insuranceTermsChecked.id !==
                          cart?.handsetData[0]?.insuranceAddOnData?.addOnId && (
                          <Box sx={styles(theme).missingItem}>
                            <EirMissingStep
                              loading={loading}
                              setIncompleteCart={setIncompleteCart}
                              action={() => {
                                dispatch({
                                  type: 'SET_INSURANCE_TERMS_CHECKED',
                                  payload: {
                                    status: false,
                                    id: cart.handsetData[0]?.insuranceAddOnData?.addOnId,
                                  },
                                });
                                setIncompleteCart(false);
                              }}
                              ctaText='Confirm'
                              missingStepMessage='false'
                              ariaLabel='Confirm'
                            />
                          </Box>
                        ))}
                    {index !== cartData.noOfBillPayOffers - 1 && (
                      <Divider sx={{ color: theme.palette.primary.disableCTA, mt: 1, mb: 1 }} />
                    )}
                  </>
                ))}
            </Box>
          </>
        )}
        {cartData?.hasSIMOnly && (
          <>
            {(cartData?.hasBroadband || cartData?.hasBillPayPlans || cartData?.hasTVOffer) &&
              !systemAddedOffer && (
                <Divider sx={{ borderColor: theme.palette.primary.offerMain }} />
              )}
            <Stack
              direction='row'
              alignItems='flex-end'
              sx={{
                pt:
                  cartData?.hasBroadband || cartData?.hasBillPayPlans || cartData?.hasTVOffer
                    ? 2.5
                    : 0,
              }}
            >
              <SIMIcon />
              <Typography
                variant='subtitle1'
                component='p'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.cartItemText?.simTitle}
              </Typography>
            </Stack>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.cart
                ?.filter(res => res.itemType === 'MOBILE' && res.isSimOnly)
                .map((cart, index) => (
                  <>
                    <EirOrderedItem
                      {...cart}
                      key={uuidv4()}
                      loading={loading}
                      cartData={cartData}
                      deleteIcon={deleteIcon}
                      openConfirmationModal={openConfirmationModal}
                      getClickedItem={getClickedItem}
                      isCartDoc={isCartDoc}
                    />
                    {cmsData && getCookie('cart_Type') !== 'CHANGE_OFFER' && (
                      <Box
                        sx={{
                          ml: {
                            xs: 0,
                            sm: 1,
                          },
                          mb: '1.5rem',
                        }}
                      >
                        <CheckoutSimSelector
                          SIMType={
                            cartAfterSIMupdate?.cart?.filter(
                              res => res.offerId === cart?.offerId
                            )[0]?.SIMCode === pSIMCode
                              ? 'ALL_IN_1'
                              : 'ESIM'
                          }
                          offerId={cart?.offerId}
                          setCartAfterSIMupdate={setCartAfterSIMupdate}
                          refreshSummary={refreshSummary}
                          SIMOnly
                          pSIMCode={pSIMCode}
                          cmsData={cmsData}
                        />
                      </Box>
                    )}
                    {cart?.activation?.price > 0 && (
                      <EirOrderedItem
                        {...cart.activation}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        isCartDoc={isCartDoc}
                      />
                    )}

                    <Stack sx={styles(theme).mobileItemDiscountContainer}>
                      {cart?.discountData
                        ?.flat()
                        .filter(s => {
                          // Hiding ACQSIMOActivationDiscount for SIMO upfront CR as workaround
                          const cartType = getCookie('cart_Type');
                          const ACQSIMOActivationDiscount =
                            s.catalogCode === 'MOBILE_ACTIVATION_FEE_1_WAIVE' &&
                            cartType !== 'CHANGE_OFFER' &&
                            cartType !== 'CROSS_SELL';
                          return s.serviceType === 'MOBILE' && !ACQSIMOActivationDiscount;
                        })
                        .map(cart1 => (
                          <EirOfferDiscounts
                            {...cart1}
                            key={uuidv4()}
                            loading={loading}
                            cartData={cartData}
                            cmsData={cmsData}
                          />
                        ))}
                    </Stack>
                    {cart?.portIn === true && cart?.portInInfo === false && !missingStep && (
                      <Box sx={{ ...styles(theme).itemDiscountContainer, padding: '0rem' }}>
                        <EirMissingStep
                          loading={loading}
                          setIncompleteCart={setIncompleteCart}
                          action={() => {
                            router.push(
                              `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/porting/?id=${cart.offerId}`
                            );
                          }}
                          ctaText='Check info'
                          missingStepMessage='Verify relevant porting information is complete'
                          ariaLabel='Relevant porting information is required'
                        />
                      </Box>
                    )}
                    {index !== cartData.noOfMobileOffers - 1 && (
                      <Divider sx={{ color: theme.palette.primary.disableCTA, mt: 1, mb: 1 }} />
                    )}
                  </>
                ))}
            </Box>
          </>
        )}

        {cartData?.hasMBBOffer && (
          <>
            {(cartData?.hasBroadband || cartData?.noOfMobileOffers > 0) && (
              <Divider sx={{ borderColor: theme.palette.primary.offerMain }} />
            )}
            <Stack
              direction='row'
              alignItems='flex-end'
              sx={{ pt: cartData?.hasMBBOffer ? 2.5 : 0 }}
            >
              <MobileBroadbandIcon />
              <Typography
                variant='subtitle1'
                component='p'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.cartItemText?.mbbTitle}
              </Typography>
            </Stack>
            <Box sx={styles(theme).itemContainer}>
              {cartData?.cart
                ?.filter(res => res.itemType === 'MBB')
                .map(cart => (
                  <>
                    <EirOrderedItem
                      {...cart}
                      key={uuidv4()}
                      loading={loading}
                      cartData={cartData}
                      deleteIcon={deleteIcon}
                      openConfirmationModal={openConfirmationModal}
                      getClickedItem={getClickedItem}
                      isCartDoc={isCartDoc}
                    />
                    {cart.addOns.map(addOn => (
                      <EirOrderedItem
                        {...addOn}
                        key={uuidv4()}
                        loading={loading}
                        cartData={cartData}
                        deleteIcon={deleteIcon}
                        openConfirmationModal={openConfirmationModal}
                        getClickedItem={getClickedItem}
                        isCartDoc={isCartDoc}
                      />
                    ))}
                    {cartData?.hasMbbDevice &&
                      cart?.mbbDongle.map(set => (
                        <EirOrderedItem
                          {...set}
                          key={uuidv4()}
                          loading={loading}
                          cartData={cartData}
                          // deleteIcon={deleteIcon}
                          openConfirmationModal={openConfirmationModal}
                          getClickedItem={getClickedItem}
                          isCartDoc={isCartDoc}
                        />
                      ))}
                    {missingStep ||
                      (cart?.mbbDongle?.length === 0 && (
                        <Box sx={styles(theme).missingItem}>
                          <EirMissingStep
                            loading={loading}
                            setIncompleteCart={setIncompleteCart}
                            action={() => {
                              router.push(
                                `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/broadband`
                              );
                            }}
                            ctaText='Add device'
                            missingStepMessage='A device needs to be added to this offer'
                            ariaLabel='A device needs to be added to the order'
                          />
                        </Box>
                      ))}
                  </>
                ))}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
export default EirOrderedOfferType;
